import * as types from './mutation-types'

export default {
    [types.ADD_PERIMETER] (state, data) {
        state.perimetersLoaded = true
        state.perimeters.push(data)
    },

    [types.ADD_PERIMETERS] (state, data) {
        state.perimetersLoaded = true
        state.perimeters = data
    },

    [types.LOAD_PERIMETER]: (state, data) => {
        let perimeterExist = state.perimeters.find(x => x.id === data.id)
        if(perimeterExist){
            state.perimeters = state.perimeters.map((x) => {
                if(x.id === data.id){
                    return data
                }

                return x
            })
        }else{
            state.perimeters.push(data)
        }
    },

    [types.LOAD_PERIMETERS]: (state, data) => {
        data.forEach((perimeter) => {
            let perimeterExist = state.perimeters.find(x => x.id === perimeter.id)
            if(perimeterExist){
                state.perimeters = state.perimeters.map((x) => {
                    if(x.id === perimeter.id){
                        return perimeter
                    }
    
                    return x
                })
            }else{
                state.perimeters.push(perimeter)
            }
        })
        
    },

    [types.DELETE_TABLE_FROM_PERIMETER]: (state, {perimeter_id, table_id}) => {
        state.perimeters = state.perimeters.map((perimeter) => {
            if(perimeter.id === perimeter_id){
                perimeter.tables = perimeter.tables.filter(table => table.id !== table_id)
            }
            return perimeter
        })
    },

    [types.ADD_TABLES_TO_PERIMETER]: (state, {perimeter_id, tables}) => {
        state.perimeters = state.perimeters.map((perimeter) => {
            if(perimeter.id === perimeter_id){
                perimeter.tables = tables
            }
            return perimeter
        })
    },

    [types.DELETE_PERIMETER]: (state, ids) => {
        state.perimeters = state.perimeters.map((perimeter) => !ids.includes(perimeter.id))
    }
}


